export default __webpack_public_path__ + "static/media/banner.402ebc52.png";